import { t } from "../i18n/index.js";

/**
 * Pasarle algo a alguien que no esta en el juego.
 *
 * En movil, el menu de compartir del sistema (WhatsApp, Telegram, Instagram:
 * lo que tenga): es como se avisa a un amigo de verdad. Donde no existe, al
 * portapapeles. Hay que llamarlo DENTRO del clic: Safari no deja abrir el menu
 * de compartir si entre el toque y la llamada ha habido una espera.
 */
export type ShareOutcome = "shared" | "copied" | "cancelled" | "failed";

export async function shareText(text: string): Promise<ShareOutcome> {
  const nav = navigator as Navigator & { share?: (data: ShareData) => Promise<void> };
  if (typeof nav.share === "function") {
    try {
      await nav.share({ title: "FYNTA", text });
      return "shared";
    } catch (err) {
      // Cerrar el menu sin elegir no es un fallo: no se copia nada a sus espaldas.
      if (err instanceof DOMException && err.name === "AbortError") return "cancelled";
    }
  }
  return (await copyText(text)) ? "copied" : "failed";
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** WhatsApp directo: en movil abre la app, en escritorio WhatsApp Web. */
export function whatsappUrl(text: string): string {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

/** El enlace a una sala, con tu codigo para que al abrirlo seais amigos. */
export function roomInviteUrl(roomId: string, friendCode?: string | null): string {
  const url = new URL(location.origin + location.pathname);
  url.searchParams.set("sala", roomId);
  if (friendCode) url.searchParams.set("de", friendCode);
  return url.toString();
}

export function roomInviteText(modeLabel: string, url: string): string {
  return t("¿Te echas un {modo} conmigo en FYNTA? Entra aquí: {url}", { modo: modeLabel, url });
}

/** Para un amigo que no esta conectado: sin sala, solo "ven". */
export function nudgeText(): string {
  return t("¿Echamos un partido en FYNTA? {url}", { url: location.origin });
}
